<ng-container>
  <div class="divider"
    [ngClass]="{
    'large': large,
    'vertical': vertical,
    'compact': compact}">
  </div>
</ng-container>
